import axios from 'axios';
// import { nativeAppFun } from './utils';

axios.defaults.headers.post['Content-Type'] = 'application/json';
axios.interceptors.request.use(config => config, error => Promise.reject(error));
axios.interceptors.response.use(resp => resp, error => Promise.resolve(error.response));
const time = new Date().getTime();
export default {
  post (url, params) {
    return new Promise((resolve, reject) => {
      axios.post(url, params, {

      }).then((res) => {
        if (!res) {
          console.error(`The request url: ${url} load fail.`);
        }
        const { data } = res || {};

        // const data1 = data.result || {};
        if (data.code === '000') {
          resolve(data);
        } else if (['4000', '4001', '4002', '4003', '4004'].indexOf(`${data.code}`) >= 0) {
          // data1.loginInvalid = true;
          setTimeout(() => {
            // nativeAppFun('IT_loginOut', { toast: '登录失效，请重新登录' }, '');// 退出登录
          }, 500);
          // reject(data1);
        } else {
          reject(data);
        }
      }, err => reject(err));
    });
  },
  get (url, params) {
    return new Promise((resolve, reject) => {
      axios.get(url, {
        data: params
      }, {
          // headers: { token: window.dataModel.token || '' }
        }).then(response => resolve(response.data), err => reject(err));
    });
  }
};
